import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Box, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import SelectAutoComplete from '../../common/autoComplete/SelectAutoComplete';
import { useSnackbar } from '../../../shared/context';

const ApproveResgistre = ({ handleChangeComponent }) => {
  const [getOptionsApproved, setOptionsApproved] = useState([]);
  const [formData, setFormData] = useState({
    approve: [],
  });
  const showSnackbar = useSnackbar();

  const handleReturnComponent = () => {
    handleChangeComponent('Consultar Aprovadores', 'consult');
  };

  const handleChangeApproved = (e, value) => {
    setFormData((prevData) => ({ ...prevData, approve: value }));
  };

  const getApproved = useCallback(async () => {
    try {
      const result = await AxiosInstance.get('/data-input/approved-registre');
      setOptionsApproved(result.data);
    } catch (error) {
      console.error('Erro ao pegar dados a requisição:', error);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('approve', JSON.stringify(formData.approve));
    formDataToSend.append('login', localStorage.getItem('@gedy:user'));

    try {
      await AxiosInstance.post('/approve/insert-approver', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Atualizado com Sucesso',
        variant: 'success',
      });
      handleReturnComponent();
    } catch (error) {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Atualizado com Sucesso',
        variant: 'success',
      });
    }
  };

  useEffect(() => {
    getApproved();
  }, [getApproved]);

  return (
    <Box m={1}>
      <form onSubmit={handleSubmit} method="POST">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} xl={12}>
            <SelectAutoComplete
              value={formData.approve}
              options={getOptionsApproved}
              label="Selecione quem serão os novos aprovadores"
              onChange={(event, selectValues) => handleChangeApproved(event, selectValues)}
              required={false}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={6}>
            <Button variant="contained" color="primary" onClick={handleReturnComponent} fullWidth>
              voltar
            </Button>
          </Grid>
          <Grid item xs={12} md={6} xl={6}>
            <Button
              type="submit" // Adicionando o tipo submit ao botão
              variant="contained"
              color="success"
              fullWidth
            >
              Criar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default ApproveResgistre;
